import { CHATBOT_TYPES } from "../actions/chatbot-actions";

const initialState = {
  // Cortex Agent conversation
  cortexMessages: {
    messages: [],
    isLoading: false,
    hasError: false,
    errorMessage: "",
  },

  // Modal state
  cortexModalOpen: false,
  pendingPrompt: null,

  // Stream notification (CortexBar indicator)
  streamNotification: null,

  // Streaming in progress (CortexBar loading state)
  isStreaming: false,

  // NLU feature flag (Cortex AI chatbot visibility)
  isNluEnabled: false,
};

const chatbotReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHATBOT_TYPES.CORTEX_ADD_MESSAGE:
      return {
        ...state,
        cortexMessages: {
          ...state.cortexMessages,
          messages: [...state.cortexMessages.messages, action.payload],
        },
      };

    case CHATBOT_TYPES.CORTEX_CLEAR_HISTORY:
      return {
        ...state,
        cortexMessages: {
          messages: [],
          isLoading: false,
          hasError: false,
          errorMessage: "",
        },
        streamNotification: null,
      };

    case CHATBOT_TYPES.OPEN_CORTEX_MODAL:
      return {
        ...state,
        cortexModalOpen: true,
        streamNotification: null,
      };

    case CHATBOT_TYPES.CLOSE_CORTEX_MODAL:
      return {
        ...state,
        cortexModalOpen: false,
      };

    case CHATBOT_TYPES.OPEN_CORTEX_MODAL_WITH_PROMPT:
      return {
        ...state,
        cortexModalOpen: true,
        pendingPrompt: action.payload,
        streamNotification: null,
      };

    case CHATBOT_TYPES.CLEAR_PENDING_PROMPT:
      return {
        ...state,
        pendingPrompt: null,
      };

    case CHATBOT_TYPES.STREAM_NOTIFICATION_SET:
      return {
        ...state,
        streamNotification: action.payload,
      };

    case CHATBOT_TYPES.STREAM_NOTIFICATION_CLEAR:
      return {
        ...state,
        streamNotification: null,
      };

    case CHATBOT_TYPES.CORTEX_START_STREAMING:
      return {
        ...state,
        isStreaming: true,
      };

    case CHATBOT_TYPES.CORTEX_STOP_STREAMING:
      return {
        ...state,
        isStreaming: false,
      };

    case CHATBOT_TYPES.SET_NLU_ENABLED:
      return {
        ...state,
        isNluEnabled: Boolean(action.payload),
      };

    default:
      return state;
  }
};

export default chatbotReducer;
